import { createFileRoute } from '@tanstack/react-router';
import { LegacyObjectsHandoff } from '@/pages/workspaces/objects/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/relationships',
)({
  component: LegacyObjectsHandoff,
});
